import { toast } from "react-toastify";
import { DOCUMENTS_LIST } from "../../Store/Type";
import { encryptVaultDocument } from "../../Componenets/Common/Encrypt-Decrypt";
import { api } from "./VaultApi";
import { encryptVaultSecret } from "../../Componenets/Common/Encrypt-Decrypt";

const apiUrl = process.env.REACT_APP_API_URL;

const getUserId = () => {
  return (
    sessionStorage.getItem("USER_ID") ||
    localStorage.getItem("USER_ID") ||
    "0001"
  );
};

export const GetDocumentsData = async ({
  dispatch,
  page = 1,
  limit = 10,
  sort_order = "D",
  sort_column = "document_id",
  type_filter = "",
  search = "",
  category_id="",
  subcategory_id=""
}) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);
  params.append("sort_order", sort_order);
  params.append("sort_column", sort_column);

  if (type_filter) {
    params.append("type_filter", type_filter);
  }

  if (search?.trim()) {
    params.append("search", search.trim());
  }

  if(category_id){
    params.append("category_id",category_id)
  }

  if(subcategory_id){
    params.append("subcategory_id",subcategory_id)
  }

  try {
    const response = await api.get(
      `${apiUrl}/getAllAdminDocument?${params.toString()}`
    );

    dispatch({
      type: DOCUMENTS_LIST,
      payload: response?.data?.data || [],
      pageContext: response?.data?.pageContext || {},
    });

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetDocumentById = async (documentId) => {
  try {
    const response = await api.get(
      `${apiUrl}/getDocumentsById/${documentId}/${getUserId()}`
    );

    return response?.data?.[0] || null;
  } catch (error) {
    handleError(error);
    return null;
  }
};

const buildDocumentFormData = async (values, otp = "") => {
  const formData = new FormData();

  if (values.document) {
    const encryptedFile = await encryptVaultDocument(values.document);

    if (!encryptedFile) {
      toast.error("Document encryption failed");
      return null;
    }

    formData.append("document", encryptedFile);
  }

  formData.append(
    "is_sensitive",
    values.is_sensitive !== undefined ? String(values.is_sensitive) : "false"
  );

  if(values.expires_at) {formData.append("expires_at", values.expires_at ? values.expires_at : "");}
  
  formData.append("description", values.description ? values.description : "");
  formData.append("user_id", getUserId());
  formData.append("category_id",values.category_id);

  if(values?.subcategory_id){
 formData.append("subcategory_id",values.subcategory_id);
  }else{
    formData.append("subcategory_id",Number(0));
  }
  if (otp) {
    formData.append("otp", otp);
  }

  return formData;
};

export const UploadDocument = async (values, documentId) => {
  const formData = await buildDocumentFormData(values);

  if (!formData) return null;

  const url = documentId
    ? `${apiUrl}/updateAdminDocument/${documentId}`
    : `${apiUrl}/uploadAdminDocument`;

  const method = documentId ? "put" : "post";

  try {
    const response = await api({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (documentId && response?.data?.message === "Otp send successfully") {
      toast.success("OTP sent successfully");
      return {
        action: "OTP_REQUIRED",
        message: response?.data?.message,
      };
    }

    toast.success(
      documentId
        ? "Document updated successfully"
        : "Document uploaded successfully"
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateUpdateDocumentOtp = async (
  documentId,
  values,
  encryptedOtp
) => {
  const formData = await buildDocumentFormData(values, encryptedOtp);

  if (!formData) return null;

  try {
    const response = await api.put(
      `${apiUrl}/validate_Update_DocumetOtp/${documentId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success(response?.data?.message || "Document updated successfully");

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const DeleteDocument = async (documentId, dispatch, filters) => {
  try {
    const response = await api.delete(
      `${apiUrl}/deleteDocumentsById/${documentId}/${getUserId()}`
    );

    if (response?.data?.message === "Otp send successfully") {
      toast.success("OTP sent successfully");
      return {
        action: "OTP_REQUIRED",
        message: response?.data?.message,
      };
    }

    toast.success(response?.data?.message || "Document deleted successfully");

    if (dispatch && filters) {
      GetDocumentsData({ dispatch, ...filters });
    }

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateDeleteDocumentOtp = async (documentId, encryptedOtp) => {
  try {
    const response = await api.delete(
      `${apiUrl}/validate_deleteDocumentsById/${documentId}`,
      {
        data: {
          user_id: getUserId(),
          otp: encryptedOtp,
        },
      }
    );

    toast.success(response?.data?.message || "Document deleted successfully");

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SearchDocuments = async ({
  dispatch,
  search,
  type_filter,
  page,
  limit,
}) => {
  try {
    if (search?.trim() || type_filter) {
      await GetDocumentsData({ dispatch, search, type_filter, page, limit });
    } else {
      await GetDocumentsData({ dispatch, page, limit });
    }
  } catch (error) {
    handleError(error);
  }
};

export const RequestOtpForViewSensitiveDocument = async (payload) => {
  try {
    const response = await api.post(
      `${apiUrl}/requestOtpForViewSensitiveDocument`,
      payload,
      {
        responseType: "blob",
      }
    );

    const contentType = response.headers["content-type"];

    if (contentType?.includes("application/json")) {
      const text = await response.data.text();
      return JSON.parse(text);
    }

    return {
      action: "DIRECT_DOWNLOAD",
      blob: response.data,
    };
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateDocumentOtp = async (payload) => {
  try {
    const response = await api.post(`${apiUrl}/validateDocumetOtp`, payload, {
      responseType: "blob",
    });

    const contentType = response.headers["content-type"];

    if (contentType?.includes("application/json")) {
      const text = await response.data.text();

      try {
        return JSON.parse(text);
      } catch {
        return null;
      }
    }

    return {
      action: "DOWNLOAD",
      blob: response.data,
    };
  } catch (error) {
    // handleError(error);
    toast.error(error.response.data.message || "Verification failed")
    return null;
  }
};

export const UpdateDocumentFavorite = async (row, isFavorite) => {
  try {
    const response = await api.put(
      `${apiUrl}/updateFavoriteStatus/${row.document_id}`,
      {
        status: isFavorite,
        user_id: getUserId(),
      }
    );

    toast.success(isFavorite ? "Document pinned" : "Document unpinned");

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const UpdateDocumentSensitive = async (row, isSensitive) => {
  try {
    const response = await api.put(
      `${apiUrl}/updateSensitiveStatus/${row.document_id}`,
      {
        status: isSensitive,
        user_id: getUserId(),
      }
    );

    if (!isSensitive && response?.data?.message === "OTP sent successfully") {
      toast.success("OTP sent successfully");
      return {
        action: "OTP_REQUIRED",
        message: response?.data?.message,
      };
    }

    toast.success(isSensitive ? "Document marked sensitive" : "Document marked non-sensitive");

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateUpdateSensitiveStatusOtp = async (
  documentId,
  encryptedOtp
) => {
  try {
    const response = await api.put(
      `${apiUrl}/validate_updateSensitiveStatus/${documentId}`,
      {
        status: false,
        user_id: getUserId(),
        otp: encryptedOtp,
      }
    );

    toast.success(
      response?.data?.message || "Document marked non-sensitive"
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SendDocumentMail = async ({ documentId, email }) => {
  try {
    const response = await api.post(`${apiUrl}/SendDocumentMail`, {
      user_id: getUserId(),
      document_id: String(documentId),
      email,
    });

    const message = response?.data?.message || "";

    if (response?.data?.action === "OTP_REQUIRED" || message.includes("OTP")) {
      toast.success("OTP sent successfully");
    } else if (message.includes("Document")) {
      toast.success("Document shared successfully");
    }
    else{
      toast.success(message);
    }

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateEmailDocumentOtp = async ({
  documentId,
  email,
  otp,
}) => {
  try {
    const encryptedOtp = await encryptVaultSecret(otp);

    const response = await api.post(
      `${apiUrl}/validateEmailDocumetOtp`,
      {
        user_id: getUserId(),
        document_id: String(documentId),
        otp: encryptedOtp,
        email,
      }
    );

   if (response?.data?.message) {
  toast.success("Document shared successfully");
}

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

const handleError = (error) => {
  console.error("Error details:", error);

  let errorMessage = "An error occurred";

  if (error.response) {
    errorMessage =
      error?.response?.data?.message ||
      `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    errorMessage = "No response received from server";
  } else {
    errorMessage = error.message;
  }

  if (
    error.code === "ERR_NETWORK" ||
    error.code === "ERR_CONNECTION_REFUSED"
  ) {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }

  toast.error(errorMessage);
};

export const GetAllDocumentCategory = async ({
  page = 1,
  limit = 10,
  search = "",
  sort_column = "category_id",
  sort_order = "DESC",
}) => {
  const response = await api.get(
    `/api/getAllDocumentCategory?page=${page}&limit=${limit}&search=${search}&sort_column=${sort_column}&sort_order=${sort_order}`
  );

  return response?.data;
};

export const GetAllDocumentSubCategory = async ({
  page = 1,
  limit = 10,
  search = "",
  sort_column = "sub_category_id",
  sort_order = "DESC",
}) => {
  const response = await api.get(
    `/api/getAllDocumentSubCategory?page=${page}&limit=${limit}&search=${search}&sort_column=${sort_column}&sort_order=${sort_order}`
  );

  return response?.data;
};
export const GetDocumentCategoryById = async (id) => {
  const response = await api.get(`/api/getDocumentCategoryById/${id}`);
  return response?.data;
};
export const GetDocumentSubCategoryById = async (id) => {
  const response = await api.get(`/api/getDocumentSubCategoryById/${id}`);
  return response?.data;
};

export const AddDocumentCategory = async (payload) => {
  const response = await api.post("/api/addDocumentCategory", payload);
  return response?.data;
};

export const UpdateDocumentCategory = async (id, payload) => {
  const response = await api.put(`/api/updateDocumentCategoryById/${id}`, payload);
  return response?.data;
};

export const DeleteDocumentCategory = async (id) => {
  const response = await api.delete(`/api/deleteDocumentCategoryById/${id}`);
  return response?.data;
};


export const AddDocumentSubCategory = async (payload) => {
  const response = await api.post("/api/addDocumentSubCategory", payload);
  return response?.data;
};

export const UpdateDocumentSubCategory = async (id, payload) => {
  const response = await api.put(`/api/updateDocumentSubCategoryById/${id}`, payload);
  return response?.data;
};

export const DeleteDocumentSubCategory = async (id) => {
  const response = await api.delete(`/api/deleteDocumentSubCategoryById/${id}`);
  return response?.data;
};

export const GetAllCategoryDropdown = async ({}) => {
  const response = await api.get(`/api/getDocumentCategoryDropdown`);
  return response.data;
};